'use client';
import { useEffect, useState } from 'react';
import { ContactUs } from './index';
import { customerModalManager, hideCustomerModal } from './customer-manager';

interface CustomerModalState {
  visible: boolean;
  config: {
    title: string;
    data: {
      name: string;
      text: string | React.ReactNode;
    };
    qrCodeSrc?: string;
    onCancel?: () => void;
  };
}

export const CustomerModalContainer = () => {
  const [modalState, setModalState] = useState<CustomerModalState | null>(null);

  useEffect(() => {
    const unsubscribe = customerModalManager.subscribe(setModalState);
    return unsubscribe;
  }, []);

  const handleCancel = () => {
    hideCustomerModal();
  };

  if (!modalState) return <></>;

  return (
    <ContactUs
      title={modalState.config.title}
      open={modalState.visible}
      greeting={modalState.config.data.name}
      content={modalState.config.data.text}
      qrCodeSrc={modalState.config.qrCodeSrc}
      onCancel={handleCancel}
    />
  );
};
